
import api from '../../../../../api.js';

export const doctorScriptStatsApi = {
  getDoctorScriptTotals: async (fromDate, toDate) => {
    try {
      const params = new URLSearchParams();

      if (fromDate) {
        params.append('fromDate', fromDate);
      }
      if (toDate) {
        params.append('toDate', toDate);
      }

      const queryString = params.toString();
      const url = queryString
        ? `/api/dispensary/reports/doctor-script-totals?${queryString}`
        : '/api/dispensary/reports/doctor-script-totals';

      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching doctor script totals:', error);
      throw error;
    }
  },
};

